import { Box, Stack } from '@mui/material';
import { MutableRefObject, useEffect, useRef, useState } from 'react';

const VolumeChecker = (props: { valueRef: MutableRefObject<number> }) => {
  const timerRef = useRef(0);
  const [value, setValue] = useState(0);

  useEffect(() => {
    timerRef.current = window.setInterval(
      () => setValue(props.valueRef.current),
      10
    );
    setValue(props.valueRef.current);
    return () => {
      window.clearInterval(timerRef.current);
    };
  }, [props]);

  const green = (number: number) =>
    value < number ? '#c9c9c9ff' : '#23b700ff';

  const yellow = (number: number) =>
    value < number ? '#c9c9c9ff' : '#d99412ff';

  const red = (number: number) => (value < number ? '#c9c9c9ff' : '#ff0000ff');

  return (
    <Stack
      my={1}
      direction={'row'}
      flexWrap={'nowrap'}
      spacing={0.5}
      sx={{ height: '35px' }}
    >
      <Box width={5} height={20} bgcolor={green(6.25)}></Box>
      <Box width={5} height={20} bgcolor={green(12.5)}></Box>
      <Box width={5} height={20} bgcolor={green(18.75)}></Box>
      <Box width={5} height={20} bgcolor={green(25)}></Box>
      <Box width={5} height={20} bgcolor={green(31.25)}></Box>
      <Box width={5} height={20} bgcolor={green(37.5)}></Box>
      <Box width={5} height={20} bgcolor={green(43.75)}></Box>
      <Box width={5} height={20} bgcolor={green(50)}></Box>
      <Box width={5} height={20} bgcolor={green(56.25)}></Box>
      <Box width={5} height={20} bgcolor={green(62.5)}></Box>
      <Box width={5} height={20} bgcolor={yellow(68.75)}></Box>
      <Box width={5} height={20} bgcolor={yellow(75)}></Box>
      <Box width={5} height={20} bgcolor={yellow(81.25)}></Box>
      <Box width={5} height={20} bgcolor={red(87.5)}></Box>
      <Box width={5} height={20} bgcolor={red(93.75)}></Box>
      <Box width={5} height={20} bgcolor={red(100)}></Box>
    </Stack>
  );
};
export default VolumeChecker;
